export const isEmulated = __EMULATED__ || (window as any).Cypress !== undefined;
export const emulatorHost = "127.0.0.1";
